import React from 'react'
import Image from 'next/image';
import { s3Static } from '../../utils/constants'
import { motion } from 'framer-motion';
import Link from 'next/link'
import { FaCcAmex, FaCcApplePay, FaCcMastercard, FaCcVisa, FaGooglePay } from 'react-icons/fa';
import { BsArrowRightCircle } from 'react-icons/bs';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

export const Features = () => {
  return (
    <div className='space-y-20 pb-20'>
        <div id="features-people" className="">
            <div className="container max-w-6xl space-y-4 pt-20 mx-auto">
                <div className='grid grid-cols-1 lg:grid-cols-2 gap-5 space-y-4'>
                    <div className='pb-5 leading-8 max-w-xl md:max-w-none mx-auto'>
                        <h2 className='text-3xl text-gray-500 mb-10 uppercase text-center font-bold'>Features</h2>
                        <p><span className='flex items-center space-x-2'>
                                <span className='text-2xl'><BsArrowRightCircle/></span>
                                <span>
                                    Book a service in less than 2 minutes.                            
                                </span>
                            </span>
                            <br></br>
                            <span className='flex items-center space-x-2'>
                                <span className='text-2xl'><BsArrowRightCircle/></span>
                                <span>
                                    Explore attractive deals.                            
                                </span>
                            </span>                            
                            <br></br>
                            <span className='flex items-center space-x-2'>
                                <span className='text-2xl'><BsArrowRightCircle/></span>
                                <span>
                                    Rewards from loyalty programs.                      
                                </span>
                            </span>                            
                            <br></br>
                            <span className='flex items-center space-x-2'>
                                <span className='text-2xl'><BsArrowRightCircle/></span>
                                <span>
                                    Enjoy heavy discounts on service booking               
                                </span>
                            </span>                            
                        </p>
                    </div>
                    <div className='flex justify-center items-center pt-2 max-w-10/12 md:max-w-none'>
                        <motion.div className='skew-x-12 rotate-45 flex items-center mb-20'
                            whileInView={{
                                scale: [0, 1.3],
                                x: [300, 60],
                                y: [10, 20],
                                rotate: [180, -45],
                                transition: {duration:1}      
                                                                
                            }} >
                            <Image className='rounded-lg shadow-2xl shadow-gray-700' height={293} width={120} src={s3Static + "stringssg-mobile-screenshot.png"} alt="StringsSG Service"/>
                        </motion.div>
                        <motion.div className='n'
                            whileInView={{
                                x: [0, 50],
                                transition: {delay: 0.5, duration:1}       
                                                                
                            }} >
                            <Image height={509} width={700} src={s3Static + "new-tablet-screenshot.png"} alt="StringsSG Service"/>
                        </motion.div>
                        
                    </div>
                </div>
            </div> 
            <div className='h-120 relative overflow-hidden'>
                <svg className='absolute m-auto left-0 h-full sm:h-auto right-0 ' xmlns="http://www.w3.org/2000/svg" id="visual" viewBox="0 0 900 600" version="1.1"><path d="M0 97L13.7 88C27.3 79 54.7 61 82 66C109.3 71 136.7 99 163.8 100C191 101 218 75 245.2 66C272.3 57 299.7 65 327 75C354.3 85 381.7 97 409 94C436.3 91 463.7 73 491 65C518.3 57 545.7 59 573 59C600.3 59 627.7 57 654.8 66C682 75 709 95 736.2 98C763.3 101 790.7 87 818 88C845.3 89 872.7 105 886.3 113L900 121L900 0L886.3 0C872.7 0 845.3 0 818 0C790.7 0 763.3 0 736.2 0C709 0 682 0 654.8 0C627.7 0 600.3 0 573 0C545.7 0 518.3 0 491 0C463.7 0 436.3 0 409 0C381.7 0 354.3 0 327 0C299.7 0 272.3 0 245.2 0C218 0 191 0 163.8 0C136.7 0 109.3 0 82 0C54.7 0 27.3 0 13.7 0L0 0Z" fill="#57657a"/><path d="M0 187L13.7 181C27.3 175 54.7 163 82 163C109.3 163 136.7 175 163.8 175C191 175 218 163 245.2 166C272.3 169 299.7 187 327 195C354.3 203 381.7 201 409 203C436.3 205 463.7 211 491 209C518.3 207 545.7 197 573 180C600.3 163 627.7 139 654.8 135C682 131 709 147 736.2 164C763.3 181 790.7 199 818 201C845.3 203 872.7 189 886.3 182L900 175L900 119L886.3 111C872.7 103 845.3 87 818 86C790.7 85 763.3 99 736.2 96C709 93 682 73 654.8 64C627.7 55 600.3 57 573 57C545.7 57 518.3 55 491 63C463.7 71 436.3 89 409 92C381.7 95 354.3 83 327 73C299.7 63 272.3 55 245.2 64C218 73 191 99 163.8 98C136.7 97 109.3 69 82 64C54.7 59 27.3 77 13.7 86L0 95Z" fill="#455367"/><path d="M0 271L13.7 268C27.3 265 54.7 259 82 257C109.3 255 136.7 257 163.8 256C191 255 218 251 245.2 258C272.3 265 299.7 283 327 290C354.3 297 381.7 293 409 286C436.3 279 463.7 269 491 263C518.3 257 545.7 255 573 239C600.3 223 627.7 193 654.8 191C682 189 709 215 736.2 234C763.3 253 790.7 265 818 262C845.3 259 872.7 241 886.3 232L900 223L900 173L886.3 180C872.7 187 845.3 201 818 199C790.7 197 763.3 179 736.2 162C709 145 682 129 654.8 133C627.7 137 600.3 161 573 178C545.7 195 518.3 205 491 207C463.7 209 436.3 203 409 201C381.7 199 354.3 201 327 193C299.7 185 272.3 167 245.2 164C218 161 191 173 163.8 173C136.7 173 109.3 161 82 161C54.7 161 27.3 173 13.7 179L0 185Z" fill="#334155"/><path d="M0 409L13.7 398C27.3 387 54.7 365 82 379C109.3 393 136.7 443 163.8 456C191 469 218 445 245.2 428C272.3 411 299.7 401 327 406C354.3 411 381.7 431 409 447C436.3 463 463.7 475 491 459C518.3 443 545.7 399 573 388C600.3 377 627.7 399 654.8 395C682 391 709 361 736.2 365C763.3 369 790.7 407 818 416C845.3 425 872.7 405 886.3 395L900 385L900 221L886.3 230C872.7 239 845.3 257 818 260C790.7 263 763.3 251 736.2 232C709 213 682 187 654.8 189C627.7 191 600.3 221 573 237C545.7 253 518.3 255 491 261C463.7 267 436.3 277 409 284C381.7 291 354.3 295 327 288C299.7 281 272.3 263 245.2 256C218 249 191 253 163.8 254C136.7 255 109.3 253 82 255C54.7 257 27.3 263 13.7 266L0 269Z" fill="#2d3849"/><path d="M0 601L13.7 601C27.3 601 54.7 601 82 601C109.3 601 136.7 601 163.8 601C191 601 218 601 245.2 601C272.3 601 299.7 601 327 601C354.3 601 381.7 601 409 601C436.3 601 463.7 601 491 601C518.3 601 545.7 601 573 601C600.3 601 627.7 601 654.8 601C682 601 709 601 736.2 601C763.3 601 790.7 601 818 601C845.3 601 872.7 601 886.3 601L900 601L900 383L886.3 393C872.7 403 845.3 423 818 414C790.7 405 763.3 367 736.2 363C709 359 682 389 654.8 393C627.7 397 600.3 375 573 386C545.7 397 518.3 441 491 457C463.7 473 436.3 461 409 445C381.7 429 354.3 409 327 404C299.7 399 272.3 409 245.2 426C218 443 191 467 163.8 454C136.7 441 109.3 391 82 377C54.7 363 27.3 385 13.7 396L0 407Z" fill="#27303e"/></svg>
                <h3 className='text-2xl md:text-3xl text-center px-2 uppercase text-white absolute left-0 right-0 z-10 top-20'>
                    <strong>Why us?</strong>
                </h3>
                <div className='text-white py-32 leading-8'>
                    <Carousel autoPlay={true} infiniteLoop={true} showThumbs={false} showStatus={false} interval={5000} preventMovementUntilSwipeScrollTolerance={true} swipeScrollTolerance={50}>
                        <div className='px-6 py-10 h-full'>
                            <h4 className='text-xl'><strong>Convenience</strong></h4>
                            <div className='py-5 max-w-3xl mx-auto'>
                                Say goodbye to endless online searches and phone calls. With StringsSG, you can easily find and book the right service provider in just a few clicks.
                            </div> 
                        </div>
                        <div className='px-6 py-10 h-full'>
                            <h4 className='text-xl'><strong>Quality Assurance</strong></h4>
                            <p className='py-5 max-w-3xl mx-auto'>
                                For job based models, we meticulously vet and verify all our onboarded teams to ensure they meet the highest standards of professionalism and expertise.
                            </p> 
                        </div>
                        <div className='px-6 py-10 h-full'>
                            <h4 className='text-xl'><strong>Customer-Centric</strong></h4>
                            <p className='py-5 max-w-3xl mx-auto'>
                                Your satisfaction is our priority. We&apos;re committed to making your service experience as smooth as possible.
                            </p> 
                        </div>
                        <div className='px-6 py-10 h-full'>
                            <h4 className='text-xl'><strong>No Hard Selling</strong></h4>
                            <p className='py-5 max-w-3xl mx-auto'>
                                We&apos;re here to provide information and support, not to pressure you into making decisions. We respect your choices and will assist you without any high-pressure sales tactics.
                            </p> 
                        </div>
                    </Carousel>      
                </div>
            </div> 
        </div>
        {/* <div id="features-sp" className="text-gray-200 bg-amber-600">
            <div className="container max-w-7xl space-y-4 px-6 pt-10">
                <div className='grid grid-cols-1 lg:grid-cols-2 gap-5 overflow-hidden'>
                    <div className='lg:flex justify-center items-center hidden sm:hidden'>
                        <motion.div className='-mb-6'
                            whileInView={{
                                x: [-300, 0],
                                transition: {duration:1}       
                                                            
                            }} >
                            <Image height={400} width={500} src={s3Static + "tablet-listing.png"} alt="StringsSG Listing"/>
                        </motion.div>
                    </div>
                    <div className='pb-5'>
                        <h2 className='text-2xl text-gray-100 mb-5'>Features for Service Providers</h2>
                        <p>View and respond to requests from people. 
                            Get instantly notified when a new request comes in the queue.
                            <br></br>
                            <br></br>
                            For services like financial consultation, gyms, personal training, interior designing, food catering and property agents, respond to request and use the chat system to discuss with the requester.
                            <br></br>
                            <br></br>
                            For services like air conditioner servicing and handyman jobs, accept a job request and payment will be credit to your account once the job is completed.
                            <br></br>
                            <br></br>
                            Post success stories and memories to the &apos;Buzz&apos;. Build connection with potential clients.
                            Get rated and reviewed for your service and build a strong profile to gain trust from future client.
                        </p>                            
                        <div className='flex justify-center w-full pt-5'>
                            <Link href="/service-provider-signup" prefetch={false}
                                className="px-6 py-3 bg-linear-to-t from-amber-600 to-amber-400 text-white hover:from-amber-500 hover:to-amber-400 focus:from-amber-500 focus:to-amber-400 rounded-full drop-shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-amber-400 ring-amber-200"
                            >
                                <strong>Service provider Sign Up</strong>
                            </Link>
                        </div>
                    </div>
                    <div className='flex justify-center lg:hidden'>
                        <motion.div className='-mb-6'
                            whileInView={{
                                x: [-300, 0],
                                transition: {duration:1}       
                                                            
                            }} >
                            <Image height={400} width={500} src={s3Static + "tablet-listing.png"} alt="StringsSG Listing"/>
                        </motion.div>
                    </div>
                    
                </div>
            </div>
        </div> */}            
        <div className='px-2'>
            <h2 className='text-2xl md:text-3xl text-center uppercase text-gray-500 leading-normal'>
                <strong>Secure Payment</strong>
            </h2>
            <div className='max-w-3xl mx-auto p-5'>                        
                <div className='px-2 flex justify-center items-center text-6xl space-x-5 py-5 text-gray-500'>
                    <FaCcVisa/><FaCcMastercard/><FaCcAmex/><FaCcApplePay/><FaGooglePay/>
                </div>                
                <div className='py-2 flex items-center '>
                    <div className='space-y-5 leading-8'>
                        <div className='flex items-center space-x-4'>
                            <span className='text-2xl'><BsArrowRightCircle/></span>
                            <span>
                                StringsSG secures your payment by the trusted Transport 
                                Layer Security (TLS 1.3), which is the highest level of network protection.
                            </span>
                        </div>
                        <div className='flex items-center space-x-4'>
                            <span className='text-2xl'><BsArrowRightCircle/></span>
                            <span>You can choose to pay with the many options available like, PayNow, Mastercard, Visa, American Express, GrabPay and many more.</span>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    </div>
    
  )
}
